module.exports = {
  type: 'hex-checkbox',
  group: 'button',
  name: '复选框',
  isForm: true,
  props: {
    innerText: {
      name: '文字',
      default: '11',
      isMain: true,
      isFormShowName: true,
      isFormField: true,
      show: {
        prop: 'isChooseDataSource',
        value: '1'
      }
    },
    id: {
      name: '控件ID',
      default: ''
    },

    class: {
      name: '控件类名',
      default: ''
    }
  },
  style: {},
  // 新的events 用来处理编译用
  interfaces: {
  },

  // events 保证原来不报错
  events: {}
}



// WEBPACK FOOTER //
// ./packages/components/checkbox/src/define.js